import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-grid-estadisticas-cultivo',
    templateUrl: './grid-estadisticas-cultivo.component.html'
})

export class GridEstadisticasCultivosComponent implements OnInit {
    private readonly _DEFAULT_ITEMS_PER_PAGE = 5;

    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 1;
    public totalItems: number;
    public firstItemList = 0;
    public lastItemList = this.itemsPerPage;
    public readonly visiblePages = 3;

    public showPais = false;
    public showCultivosNumber = false;
    public showCultivosPercentage = false;
    public showDenominacion = false;
    public showCampanya = false;
    public showAforoNumber = false;
    public showAforoPercentage = false;
    public showSuperficieNumber = false;
    public showSuperficiePercentage = false;

    @Input() dataGrid: any;

    @Output() hideTable = new EventEmitter<boolean>();
    
    constructor(
        private readonly _translate: TranslateService
    ) {}

    ngOnInit(): void {
        this.totalItems = this.dataGrid.length;
        this.showRightFields();
    }

    public get defaultLanguage() {
        return this._translate.getDefaultLang();
    }

    private showRightFields() {
        // Con que exista esa propiedad/no esté vacía en algún objeto, hay que mostrar ese campo
        this.dataGrid.forEach(object => {
            if (object.desPais) {
                this.showPais = true;
            }
            if (object.numCultivos) {
                this.showCultivosNumber = true;
            }
            if (object.porcentajeCultivos) {
                this.showCultivosPercentage = true;
            }
            if (object.desDenominacion) {
                this.showDenominacion = true;
            }
            if (object.anyo) {
                this.showCampanya = true;
            }
            if (object.sumAforos) {
                this.showAforoNumber = true;
            }
            if (object.porcentajeAforo) {
                this.showAforoPercentage = true;
            }
            if (object.sumSuperficies) {
                this.showSuperficieNumber = true;
            }
            if (object.porcentajeSuperficie) {
                this.showSuperficiePercentage = true;
            }
        })
    }

    public pageChange(page) {
        this.currentPage = page;
        this.firstItemList = this.itemsPerPage * (page - 1);
        this.lastItemList = this.itemsPerPage * page;
    }

    public itemsPerPageChange(items) {
        this.currentPage = 1;
        this.itemsPerPage = items;
        this.firstItemList = 0;
        this.lastItemList = items;
    }

    public close() {
        this.hideTable.emit(true);
    }
}